import { useState } from 'react';
import CardSearchInput from '../../cardMenu/components/CardSearchInput';
import { useFullPlaylist } from '../savedItemsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useFilteredPlaylistItems = (items, searchText) => {
  if (!items) return null;
  if (!searchText || !searchText.length) return items;
  const lowerSearchText = searchText.toLowerCase();
  return items.filter(({
    name
  }) => name.toLowerCase().includes(lowerSearchText));
};
const PlaylistItemsSearch = ({
  playlistId,
  render
}) => {
  const [searchText, setSearchText] = useState('');
  const {
    playlist,
    playlistLoading,
    displayedPlaylistItems
  } = useFullPlaylist(playlistId);
  const displayedItems = useFilteredPlaylistItems(displayedPlaylistItems, searchText);
  if (playlistLoading) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardSearchInput, {
      onSearchChange: text => setSearchText(text),
      placeholder: "academyCommon.cardMenu.searchItemsPlaceholder"
    }), render(playlist || null, displayedItems)]
  });
};
export default PlaylistItemsSearch;